import { Box, IStackProps, VStack } from 'native-base';
import React, { ReactNode } from 'react';

import { IconComponent, IconProps } from 'app/hocs/withIconWrapper';
import { tID } from 'app/services/TestHelper';

export type ReservationDetailProps = IStackProps & {
  children?: ReactNode;
  Icon: IconComponent;
  _icon?: IconProps;
};

export default function ReservationDetail({
  children,
  Icon,
  _icon,
  ...props
}: ReservationDetailProps) {
  return (
    <VStack
      alignItems="center"
      justifyContent="flex-start"
      space="1"
      testID={tID('ReservationDetail')}
      w="full"
      {...props}
    >
      <Box alignItems="center" h="6" justifyContent="center" w="6">
        <Icon color="white" size={24} {..._icon} />
      </Box>
      <Box alignItems="center" justifyContent="flex-start" minH="4" w="full">
        {children}
      </Box>
    </VStack>
  );
}
